import { useState } from 'react';
import { Modal, InputLabel, TextAreaInput } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';

export interface AnswerReportProblemModalProps
  extends CommonModalProps<string> {
  Q: string;
}

const AnswerReportProblemModal: React.FC<AnswerReportProblemModalProps> = ({
  Q,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [answer, setAnswer] = useState('');
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Answer"
      onSubmit={() => {
        onSubmit && onSubmit(answer);
      }}
    >
      <div>
        <InputLabel text={Q} name="Q" />
        <TextAreaInput
          name="answer"
          value={answer}
          rows={5}
          onChange={(_, val) => setAnswer(val)}
          label="Answer"
        />
      </div>
    </Modal>
  );
};

export default AnswerReportProblemModal;
